var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 396,
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-776 -396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M796.5 398.3C797.052 398.3 797.5 398.748 797.5 399.3L797.5 405.9C797.5 406.452 797.052 406.9 796.5 406.9L781.2 406.9 781.2 412.8 783.5 412.8 783.5 410.1C783.5 409.548 783.948 409.1 784.5 409.1L796.5 409.1C797.052 409.1 797.5 409.548 797.5 410.1L797.5 416.7C797.5 417.252 797.052 417.7 796.5 417.7L784.5 417.7C783.948 417.7 783.5 417.252 783.5 416.7L783.5 414 780.6 414C780.269 414 780 413.731 780 413.4L780 413.388 780 406.9 779.5 406.9C778.948 406.9 778.5 406.452 778.5 405.9L778.5 399.3C778.5 398.748 778.948 398.3 779.5 398.3L796.5 398.3ZM796.3 410.3 784.7 410.3 784.7 416.5 796.3 416.5 796.3 410.3ZM796.3 399.5 779.7 399.5 779.7 405.7 796.3 405.7 796.3 399.5Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.8d6b84d5254af465056f59ed9ffa36a2.svg";
export { ForwardRef as ReactComponent };